var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    className: "injected-svg",
    "data-src": "/static/media/google-drive.f31dc716.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15479 24L9.77226 16H28.2436L23.6257 24H5.15479Z",
    fill: "#3777E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0083 16H28.2437L19.0083 0H9.77234L19.0083 16Z",
    fill: "#FFCF63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.536621 16L5.15473 24L14.3901 8.00001L9.7722 0L0.536621 16Z",
    fill: "#11A861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/googleDrive.cae025a8394697cc1c43a2abd07fe951.svg";
export { ForwardRef as ReactComponent };